import { z } from 'zod';

import { zGoDate, zGoSlice } from '../helpers/fix-go-types';

export const ReceiptItemSchema = z.object({
  code_num: z.string(),
  product: z.string(),
  size: z.string(),
  barcode: z.string(),
  price: z.number(),
  quantity: z.number(),
  discount: z.number(),
  cost: z.number(),
});

export type ReceiptItem = z.infer<typeof ReceiptItemSchema>;

export const PaymentInfoSchema = z.object({
  type: z.enum(['cash', 'card', 'check', 'gift_card', 'other']),
  card_brand: z.string().optional(),
  card_last4: z.string().optional(),
});

export type PaymentInfo = z.infer<typeof PaymentInfoSchema>;

export const ReceiptSchema = z.object({
  invoice_number: z.number(),
  timestamp: zGoDate,
  station: z.string(),
  initials: z.string(),
  closing_id: z.string(),
  // Go serializes a nil `[]ReceiptItem` (no omitempty) as `null`; zGoSlice
  // coerces that to `[]` so a receipt with no lines still validates.
  items: zGoSlice(ReceiptItemSchema),
  sub_total: z.number(),
  tax: z.number(),
  total: z.number(),
  payment: PaymentInfoSchema.optional(),
  payment2: PaymentInfoSchema.optional(),
});

export type Receipt = z.infer<typeof ReceiptSchema>;
